import React, { useState, useEffect, useContext } from 'react';

import './bls-insights.scss';
import { default as t } from '../../../utils/i18n';
import { Table, Pagination } from 'rsuite';
import { BlsService } from '../../../services';
import { UserContext, ToasterContext } from '../../../context';
import { ActionLink, Button, Dropdown } from '../../atoms';
import { useHistory } from 'react-router-dom';
import { DashService } from '../../../services';
import { navigateUrl } from '../../../utils/malaRedirect';

const BlsInsights = props => {
  const { Column, HeaderCell, Cell } = Table;
  const [limit, setLimit] = React.useState(10);
  const [page, setPage] = React.useState(1);
  const [show, showstyle] = useState('');
  const [searchItem, setSearchItem] = useState('');
  const [businessManagers, setBusinessManagers] = useState('');
  const [blsData, setBlsData] = useState('');
  const { user, setUser } = useContext(UserContext);
  const username = user?.username;
  const userAccessToken = user?.tokens?.accessToken?.jwtToken;
  const history = useHistory();
  const [selectedAdAccount, setSelectedAdAccount] = useState('');
  const [selectedBM, setSelectedBM] = useState('');
  const [adAccounts, setAdAccounts] = useState([]);
  const { message, setMessage } = useContext(ToasterContext);
  const [toaster, setToaster] = useState(false);
  const [isNickName, setIsNickName] = useState(true);

  useEffect(() => {
    if (message?.message) {
      setToaster(true);
      clearToaster();
    }
    getBusinessManager();
  }, []);

  const clearToaster = () => {
    setTimeout(() => {
      console.log('clear called');
      setToaster(false);
    }, 7000);
  };

  async function getBusinessManager() {
    try {
      const bmResponse = await DashService.bmList(userAccessToken, username);
      let selectedBmData;
      let businessManagersList = bmResponse.data?.data?.map(businessMs => {
        const data = {
          value: businessMs.id,
          label: businessMs.name,
        };
        if (user?.isMalaRedirect && user.dropdowns?.businessManager?.value === businessMs.id) {
          selectedBmData = data;
        }
        return data;
      });
      setBusinessManagers(businessManagersList);
      if (user.dropdowns?.businessManager) {
        if (selectedBmData) {
          setSelectedBM(selectedBmData);
          setUser(prev => ({
            ...prev,
            dropdowns: {
              ...prev.dropdowns,
              businessManager: selectedBmData,
            },
          }));
          getAdAccounts(selectedBmData);
        } else {
          setSelectedBM(user.dropdowns?.businessManager);
          getAdAccounts(user.dropdowns?.businessManager);
        }
      } else {
        setSelectedBM(businessManagersList[0]);
        getAdAccounts(businessManagersList[0], false);
      }
    } catch (error) {
      setBlsData('');
      const dataCode = error?.data?.data?.code;
    }
  }

  async function getAdAccounts(selectedOption, selectFromContext = true) {
    try {
      const adAcResponse = await DashService.adAccountList(
        userAccessToken,
        username,
        selectedOption.value
      );
      let selectedAdAccData;
      let adAccountList = adAcResponse.data?.data?.map(adAccounts => {
        const data = {
          value: adAccounts.id,
          label: adAccounts.name,
        };
        if (user?.isMalaRedirect && user.dropdowns?.adaccount?.value === adAccounts.id) {
          selectedAdAccData = data;
        }
        return data;
      });
      setAdAccounts(adAccountList);
      if (selectFromContext && user.dropdowns?.adaccount) {
        if (selectedAdAccData) {
          setSelectedAdAccount(selectedAdAccData);
          setUser(prev => ({
            ...prev,
            dropdowns: {
              ...prev.dropdowns,
              adaccount: selectedAdAccData,
            },
          }));
          if (user.redirectData?.blsData?.hasUploaded) {
            setUser(prev => ({
              ...prev,
              redirectData: {
                ...prev.redirectData,
                blsData: {
                  ...prev.redirectData.blsData,
                  adaccount: selectedAdAccData,
                },
              },
            }));
          }
          getBlsData(1, '', 10, selectedAdAccData);
        } else {
          setSelectedAdAccount(user.dropdowns?.adaccount);
          getBlsData(1, '', 10, user.dropdowns?.adaccount);
        }
      } else {
        setSelectedAdAccount('');
        setUser(prevUserState => ({
          ...prevUserState,
          dropdowns: {
            businessManagers: selectedOption,
            adaccount: '',
          },
        }));
      }
    } catch (error) {
      setAdAccounts([]);
      setBlsData('');
      const dataCode = error?.data?.data?.code;
    }
  }

  async function getBlsData(pageNo, searchKeyword, limit = 10, adAccount) {
    let adAccountVal = adAccount ? adAccount : selectedAdAccount;
    try {
      const bmResponse = await BlsService.getBlsList(
        userAccessToken,
        username,
        adAccountVal?.value,
        limit,
        pageNo,
        searchKeyword
      );
      bmResponse?.data?.data?.blsStudyDataList?.forEach(study => {
        study.dateRange = getDateRange(study.startDate, study.endDate);
        study.uploadedOn = updateDateFormat(study.uploadedOn);
      });
      setBlsData({ ...bmResponse?.data?.data });
    } catch (error) {
      setBlsData('');
      const dataCode = error?.data?.data?.code;
    }
  }

  const getDateRange = (startTime, stopTime) => {
    if (stopTime) {
      return updateDateFormat(startTime) + ' to ' + updateDateFormat(stopTime);
    } else {
      return updateDateFormat(startTime) + ' ' + 'onwards';
    }
  };

  const updateDateFormat = val => {
    const d = new Date(val);
    d.setUTCHours(0, 0, 0, 0);
    const yyyy = d.getFullYear();
    let mm = d.getMonth() + 1; // Months start at 0!
    let dd = d.getDate();

    if (dd < 10) dd = '0' + dd;
    if (mm < 10) mm = '0' + mm;
    return dd + '-' + mm + '-' + yyyy;
  };

  const getWidth = (value = 9) => {
    return window.innerWidth / value;
  };

  const handleOnView = (e, rowData) => {
    e.preventDefault();
    history.push(`/view-bls-study?accountId=${rowData?.studyId}`);
  };

  const onClikAdd = () => {
    history.push('/add-bls-study');
  };

  const handleOnSelectBM = selectedOption => {
    setSelectedBM(selectedOption);
    setSelectedAdAccount('');
    setBlsData('');
    getAdAccounts(selectedOption, false);
    setUser(prevUserState => ({
      ...prevUserState,
      dropdowns: {
        adaccount: '',
        businessManager: selectedOption,
      },
    }));
  };

  const handleOnSelectAdAccount = selectedOption => {
    setSelectedAdAccount(selectedOption);
    getBlsData(1, searchItem, limit, selectedOption);
    setUser(prevUserState => ({
      ...prevUserState,
      dropdowns: {
        adaccount: selectedOption,
        businessManager: selectedBM,
      },
    }));
  };
  const handleChangeLimit = dataKey => {
    setPage(1);
    setLimit(dataKey);
    getBlsData(1, searchItem, dataKey);
  };

  const pageChange = page => {
    setPage(page);
    getBlsData(page, searchItem);
  };
  const filterHandler = keyword => {
    if (!keyword.trim()) {
      showstyle('');
      setSearchItem('');
      getBlsData(1, '');
    } else {
      showstyle('show');
      setSearchItem(keyword);
      getBlsData(1, keyword);
    }
  };

  const toggleName = e => {
    e.stopPropagation();
    setIsNickName(!isNickName);
  };

  const NameCell = ({ rowData, dataKey, isNickName, ...props }) => {
    return (
      <Cell {...props}>
        <div>{isNickName ? rowData[dataKey] : rowData['studyName']}</div>
      </Cell>
    );
  };

  return (
    <section>
      <div className="bls_insights_container">
        {user?.isMalaRedirect ? (
          <div className="mala-redirect-button">
            <Button
              type="button"
              label={t('Back to Manage Learning Agenda')}
              handleClick={() => {
                navigateUrl(user);
              }}
            ></Button>
          </div>
        ) : null}

        <div className="import-campaigns-container-details">
          <div className="topContainer">
            <h3>{t('bls.dashboard.header')}</h3>
            <span>{t('bls.dashboard.subheader')}</span>
            <br></br>
          </div>
          <div className="listing-container optimisation">
            <div className="filter-section">
              <div className="left-section">
                <div style={{ width: '189px', height: '67px' }}>
                  <Dropdown
                    className="user-select"
                    heading={t('perf.business.manager')}
                    value={selectedBM}
                    options={businessManagers}
                    onSelect={handleOnSelectBM}
                    placeholder={t('create.report.share.modal.placeholder1')}
                    tooltipIndicator={true}
                    tooltipId={t('business-manager')}
                    infoData={t('optimisation.table.businessManager')}
                  />
                </div>
                <div className="ad-account" style={{ width: '306px', height: '67px' }}>
                  <Dropdown
                    heading={t('perf.ad.account')}
                    value={selectedAdAccount}
                    options={adAccounts}
                    onSelect={handleOnSelectAdAccount}
                    placeholder={t('search.for.adaccount')}
                    tooltipIndicator={true}
                    searchIndicator={true}
                    tooltipId={t('ad-account')}
                    infoData={t('optimisation.table.adAccount')}
                    search={true}
                  />
                </div>
              </div>
              <div>
                {user?.redirectData?.blsData?.hasUploaded &&
                user.dropdowns?.adaccount?.value ===
                  user.redirectData.blsData?.adaccount?.value ? null : (
                  <div className="add-bm">
                    <button
                      className="step-back"
                      onClick={onClikAdd}
                      disabled={!selectedAdAccount?.value}
                    >
                      {t('bls.dashboard.addBtn')}
                    </button>
                  </div>
                )}
              </div>
            </div>
          </div>

          <div className="search-section-container search_align_end ">
            <h3></h3>
            <div className="search-field">
              <i className="eva eva-search-outline search-icon"></i>
              <input
                type="text"
                name="search"
                placeholder={t('bls.dashboard.search')}
                onChange={e => filterHandler(e.target.value, e)}
                value={searchItem}
                autoComplete="off"
              />
              <button
                type="button"
                className={`clear-btn ${show}`}
                onClick={e => filterHandler('')}
              >
                <i className="eva eva-close-outline clear-icon"></i>
              </button>
            </div>
          </div>
          <div className="sticky-toaster">
            {toaster ? (
              <div className="report-toaster report-toaster-pos">
                {!message.isError && (
                  <span>
                    <i className="eva eva-checkmark-outline"></i>
                  </span>
                )}
                {message.isError && (
                  <div className="icon-error">
                    <i className="eva eva-close-outline"></i>
                  </div>
                )}
                {message?.message}
              </div>
            ) : (
              ''
            )}
          </div>
          <div>
            <Table
              autoHeight
              data={blsData?.blsStudyDataList}
              bordered
              cellBordered
              className="admin-table"
            >
              <Column width={getWidth(6)}>
                <HeaderCell>
                  <i
                    className="eva eva-repeat-outline"
                    data-tip={isNickName ? t('bls.tooltip.toggle1') : t('bls.tooltip.toggle2')}
                    data-for="tool-tip"
                    onClick={event => toggleName(event)}
                  ></i>
                  {isNickName ? t('bls.table.study.id') : t('bls.table.study.name')}
                </HeaderCell>
                <NameCell dataKey="studyId" isNickName={isNickName} />
              </Column>

              <Column width={getWidth(6)}>
                <HeaderCell>{t('bls.table.duration')}</HeaderCell>
                <Cell dataKey="dateRange" />
              </Column>

              <Column width={getWidth()}>
                <HeaderCell>{t('bls.table.measured.campaigns')}</HeaderCell>
                <Cell dataKey="measuredCampaigns" />
              </Column>

              <Column width={getWidth()}>
                <HeaderCell>{t('bls.study.cells')}</HeaderCell>
                <Cell dataKey="numberOfCells" />
              </Column>
              <Column width={getWidth(5)}>
                <HeaderCell>{t('bls.study.uploaded.by')}</HeaderCell>
                <Cell dataKey="uploadedBy" />
              </Column>
              <Column width={getWidth()}>
                <HeaderCell>{t('bls.study.uploaded.on')}</HeaderCell>
                <Cell dataKey="uploadedOn" />
              </Column>
              <Column width={getWidth()}>
                <HeaderCell></HeaderCell>
                <Cell align="center">
                  {rowData => (
                    <span className="view-details">
                      <i className="eva  eva-arrow-forward-outline"></i>
                      <ActionLink
                        redirectTo={''}
                        value={t('bls.study.view')}
                        handleClick={e => handleOnView(e, rowData)}
                      />
                    </span>
                  )}
                </Cell>
              </Column>
            </Table>
          </div>
          <div className="pagination-div">
            <span>{t('reports.per.page')}</span>
            <Pagination
              prev
              next
              first
              last
              ellipsis
              boundaryLinks
              maxButtons={5}
              layout={['-', 'limit', '|', 'pager']}
              total={blsData?.pagination?.totalRecords}
              limitOptions={[10, 15]}
              limit={limit}
              activePage={page}
              onChangePage={page => {
                pageChange(page);
              }}
              onChangeLimit={handleChangeLimit}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default BlsInsights;
